export default __webpack_public_path__ + "static/externalities_public_finance-f37e54631297c3b8d52169e434ff83d6.png";